import styled from 'styled-components';

export const Container = styled.header`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0 1.5rem 0.5rem 1.5rem;
  border-radius: 0.25rem;
  margin: 0 auto 1rem;

  .hefesto-input-wrapper__label-wrapper__label::after {
    content: '*';
    color: ${({ theme }) => theme.colors.purple};
  }

  > div {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 0 auto 1rem;
  }

  & h1 {
    font-weight: 600;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.grayDark3};
  }

  & > .subtitle {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
    font-family: ${({ theme }) => theme.fonts.workSans};
  }
`;

export const BlueFontRowActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;

  span.hefesto-button__label {
    color: #244577;
  }
`;
